import { Alert, AlertDescription, AlertIcon, AlertTitle, Button, Divider, Flex, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { BsEnvelope, BsPlus } from 'react-icons/bs'
import ModalEmailAdd from '../components/adminEmail/ModalEmailAdd'
import TableAdminEmail from '../components/adminEmail/TableAdminEmail'
import { BlockContainer, BlockContent, BlockHeader } from '../components/shared/Block'
import SelectedItemAlertContext, { AL_CREATE, itemData, useSelectedItemAlertContext } from '../context/selectedItemAlertContext'

const AddEmailButton = () => {
    const { setItemData } = useSelectedItemAlertContext()
    const onClickHandle = () => {
        setItemData(itemData(0, AL_CREATE))
    }
    return (
        <Button size="sm" variant="outline"
            colorScheme="green" leftIcon={<BsPlus />}
            onClick={onClickHandle}
        >เพิ่มรูปแบบ</Button>
    )
}

const AdminEmail = () => {
    const [itemData, setItemData] = useState(null)

    return (
        <Flex p="40px" direction="column" w="full">
            <SelectedItemAlertContext.Provider value={[itemData, setItemData]}>
                <BlockContainer>
                    <BlockHeader title="รายการแบบแจ้งผลทางอีเมล" icon={BsEnvelope}>
                        <AddEmailButton />
                    </BlockHeader>
                    <Divider />
                    <BlockContent mt={6}>
                        <VStack w="full" spacing={8}>
                            <Alert status="info">
                                <VStack align="start">
                                    <Flex>
                                        <AlertIcon />
                                        <AlertTitle mr={2}>คำชี้แจง</AlertTitle>
                                    </Flex>
                                    <AlertDescription>ข้อมูลรูปแบบอีเมล หมายถึงข้อมูลต้นแบบที่จะไปแสดงบนอีเมลตอบกลับไปยังผู้ยื่นคำร้องในกรณีต่างๆ เช่น การส่งผลการตรวจเอกสาร การส่งวันนัดเข้ามาทำสัญญา เป็นต้น</AlertDescription>
                                </VStack>
                            </Alert>
                            <TableAdminEmail />
                            {itemData?.type === AL_CREATE && <ModalEmailAdd data={itemData} />}
                        </VStack>
                    </BlockContent>
                </BlockContainer>
            </SelectedItemAlertContext.Provider>
        </Flex>
    )
}

export default AdminEmail
